import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const submitComparativeEvidenceReportData = async (apiToken = null, tableState, groupReferencesState, introductionState, picoClassifiersState) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!groupReferencesState.populationName) {
        alert("No population value.");
        return null;
    }
    if (!groupReferencesState.interventionName) {
        alert("No intervention value.");
        return null;
    }
    if (!groupReferencesState.comparatorName) {
        alert("No comparator value.");
        return null;
    }
    if (!tableState.length) {
        alert("No outcome data.");
        return null;
    }
    for (const row of tableState) {
        if (!row.outcomeName) {
            alert("Missing outcome name.");
            return null;
        }
    }
    //CALLING SERVER with createcompositionevidencereport) 
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'createcompositionevidencereport',
            'apiToken': apiToken,
            'tableState': tableState,
            'groupReferencesState': groupReferencesState,
            'introductionState': introductionState,
            'picoClassifiersState': picoClassifiersState
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from createcompositionevidencereport call");
    }).catch((error) => { console.log(error); });
};

const submitComparativeEvidenceReportFromResearchStudy = async (apiToken = null, createComparativeEvidenceReportModalState) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!createComparativeEvidenceReportModalState.title) {
        alert("No title.");
        return null;
    }
    if (!createComparativeEvidenceReportModalState.researchStudyReference) {
        alert("No researchStudyReference.");
        return null;
    }
    if (!createComparativeEvidenceReportModalState.eligibilityCriteriaReference && !createComparativeEvidenceReportModalState.studyGroupReference) {
        alert("No population value.");
        return null;
    }
    if (!createComparativeEvidenceReportModalState.interventionDescription && !createComparativeEvidenceReportModalState.interventionGroupReference) {
        alert("No intervention value.");
        return null;
    }
    if (!createComparativeEvidenceReportModalState.comparatorDescription && !createComparativeEvidenceReportModalState.comparatorGroupReference) {
        alert("No comparator value.");
        return null;
    }
    //CALLING SERVER with createcomparativeevidencereportfromresearchstudy) 
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'createcomparativeevidencereportfromresearchstudy',
            'apiToken': apiToken,
            'createComparativeEvidenceReportModalState': createComparativeEvidenceReportModalState
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from createcomparativeevidencereportfromresearchstudy call");
    }).catch((error) => { console.log(error); });
};

const submitComparativeEvidenceSynthesisReportData = async (apiToken = null, tableState, groupReferencesState, introductionState, picoClassifiersState) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!groupReferencesState.populationName) {
        alert("No population value.");
        return null;
    }
    if (!groupReferencesState.interventionName) {
        alert("No intervention value.");
        return null;
    }
    if (!groupReferencesState.comparatorName) {
        alert("No comparator value.");
        return null;
    }
    if (!tableState.length) {
        alert("No outcome data.");
        return null;
    }
    for (const row of tableState) {
        if (!row.outcomeName) {
            alert("Missing outcome name.");
            return null;
        }
    }
    //CALLING SERVER with createcompositionevidencesynthesisreport) 
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'createcompositionevidencesynthesisreport',
            'apiToken': apiToken,
            'tableState': tableState,
            'groupReferencesState': groupReferencesState,
            'introductionState': introductionState,
            'picoClassifiersState': picoClassifiersState
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from createcompositionevidencesynthesisreport call");
    }).catch((error) => { console.log(error); });
};

export default submitComparativeEvidenceReportData;
export { submitComparativeEvidenceSynthesisReportData, submitComparativeEvidenceReportFromResearchStudy };